import { useTranslation } from 'react-i18next'

import { EmailInput, InputWithLabel, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ContactInformation = ({ onChangeContactEmail, contactEmail, onChangeContactUrl, contactUrl }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="titleM" tag="h3" customStyles={{ fontWeight: 600 }}>
        {t('Datos de contacto')}
      </Text>
      <div>
        <EmailInput label={t('Email de contacto para clientes')} onChange={onChangeContactEmail} value={contactEmail} />
        <InputWithLabel
          label={t('URL de contacto para clientes')}
          onChange={onChangeContactUrl}
          value={contactUrl}
          fullWidth
        />
      </div>
    </Styles.Container>
  )
}

export default ContactInformation
